require('./icons/css/nucleo-glyph.css');
require('./icons/css/nucleo-mini.css');
require('./icons/css/nucleo-outline.css');

require('./sass/common.sass');
require('./sass/loader.sass');

require('./sass/privacy.sass');

require('./sass/components/alert.sass');
require('./sass/components/callouts.sass');
require('./sass/components/dropselect.sass');
require('./sass/components/forms.sass');
require('./sass/components/froala-theme.sass');
require('./sass/components/inline_editor.sass');
require('./sass/components/modals.sass');
require('./sass/components/preview.sass');
require('./sass/components/file_previewer.sass');

require('./sass/components/callouts.sass');
require('./sass/components/submenu.sass');
require('./sass/components/slideout.sass');
require('./sass/components/select/multiselect.sass');
require('./sass/components/froala-theme.sass');
require('./sass/components/dropselect.sass');
require('./sass/components/popover.sass');

require('./sass/diagnostics.sass');

require('./components/ads/main.css');
require('./components/smapply-ui/styles/smapply-ui.scss');

require('./components/cookie_banner.js');
require('./components/one_trust.js');

require('./downloads.js');
require('./callouts.js');
require('./reverse.js');
require('./ajax_modal.js');
require('./drafting.js');
require('./base.js');
require('./components/popover.js');
require('./components/multi_select_search.js');
require('./components/select_search.js');

require('./components/slideout.js');
require('./components/select/multiselect.js');

require('./localize.js');

require('./components/react/components/SystemAlerts.jsx');
require('./components/ads/inline-editor/InlineEditor.jsx');
require('./components/ads/menu/Menu.jsx');
require('./components/ads/textarea/Textarea.jsx');
require('./components/smapply-ui/withFetcher');
require('./components/smapply-ui/AdvancedSelect.jsx');
require('./components/smapply-ui/Switch.jsx');

module.exports = {
	renderRC: require('sma.admin/components/react/render').default,

	SystemAlerts: require('sma.common/components/react/components/SystemAlerts').default,
};
